import {Component, OnInit, Input, SimpleChanges, Output, EventEmitter, ChangeDetectorRef, OnChanges, ComponentFactoryResolver} from '@angular/core';
import {FormBuilder, FormControl, Validators, AbstractControl, FormGroup, FormArray} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Breakdown} from 'src/app/model/quote/breakdown/breakdown.model';
import {MatSnackBar} from '@angular/material/snack-bar';
import {BreakdownService} from '../breakdown.service';
import { coerceBreakdownIsMicroEnterprise, isFirstBreakdownMtaSave, resolveBreakdownOldPolicyId } from '../breakdown-policy-holder.util';
import {ActivatedRoute} from '@angular/router';
import { AmlineService } from '../../amline/amline.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-breakdown-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.css', '../../quote.component.css']
})
export class BreakdownVehiclesComponent implements OnInit, OnChanges {
  public formFields: FormGroup;
  public submitted: boolean = false;
  public validationMsgForPopUp: string = '';
  public dont_have_driver_name: boolean = true;
  public driver_forename: string = '';
  public driver_surname: string = '';
  public driver_title: string;
  public helptext: string = '';
  public grossWeightOptions: String[] = ['Up to 7.5T.', 'Over 7.5T.']
  private drivers_list: any;
  private driversFullList: any;
  private UniqueID: any;
  public vehicleOptions: {label: string, id: string}[]
  private lastPatchedQuoteId: string = null;

  @Input() staticData;
  @Input() modelObject;
  @Input() apiModelObject;
  @Input() originalPolicyId: string | null = null;
  @Input() authDetails;
  @Output() modelObjectUpdated = new EventEmitter<Breakdown>();

  constructor(
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private _snackBar: MatSnackBar,
    private breakdownService: BreakdownService,
  ) {}

  public ngOnInit(): void {
    this.getVehicleOptions();

    this.formFields = this.formBuilder.group({
      vehicles: this.formBuilder.group({
        registration_number: ['', Validators.required],
        make: ['', Validators.required],
        model: ['', Validators.required],
        year: ['', Validators.required],
        weight: ['', Validators.required],
        kept_at_postcode: ['', Validators.required],
        vehicle_hb_weight_id: [''],
      }),
      drivers: this.formBuilder.array([]),
    });

    // uppercase all letter values on registration number value changes
    this.vehicles.get('registration_number').valueChanges.subscribe((value) => {
        if (value && value.length > 0) {
          this.vehicles.get('registration_number').setValue(value.toUpperCase(), { emitEvent: false });
        }
    });

    // uppercase all letter values on postcode value changes
    this.vehicles.get('kept_at_postcode').valueChanges.subscribe((value) => {
      if (value && value.length > 0) {
        this.vehicles.get('kept_at_postcode').setValue(value.toUpperCase(), { emitEvent: false });
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.apiModelObject) {
      const quoteId = this.apiModelObject.id;
      if (quoteId !== this.lastPatchedQuoteId) {
        this.lastPatchedQuoteId = quoteId;
        this.getVehicleOptions();

        this.modelObject = this.apiModelObject;
        const vehicles = this.modelObject?.vehicles;
        const vehicle = Array.isArray(vehicles) ? vehicles[0] : vehicles;

        if (vehicle) {
          this.formFields.patchValue({
            vehicles: {
              registration_number: vehicle.registration_number,
              make: vehicle.make,
              model: vehicle.model,
              year: vehicle.year,
              kept_at_postcode: vehicle.kept_at_postcode
            }
          });
        }
      } else {
        this.modelObject = this.apiModelObject;
      }
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.formFields.controls;
  }

  get vehicles(): FormArray { return this.formFields.get('vehicles') as FormArray; }

  /**
   * Get vehicle weight and year options to calculate premiums 
   */
  public getVehicleOptions(){
    this.breakdownService
      .getHorseboxOptions()
      .subscribe((response: any) => { 
        this.vehicleOptions = response.result;
        
        if(this.apiModelObject) {
          console.log('API Model Object:', this.apiModelObject);
          const vehicles = this.apiModelObject?.vehicles;
          const vehicle = Array.isArray(vehicles) ? vehicles[0] : vehicles;
          console.log('Vehicle Options:', this.vehicleOptions);
          console.log('Vehicle:', vehicle);

          if (!vehicle?.vehicle_hb_weight_id) {
            return;
          }

          const vehicleOption = this.vehicleOptions?.find((option) => option.id === vehicle.vehicle_hb_weight_id);
          const weightControl = this.formFields?.get('vehicles')?.get('weight');
          if (!vehicleOption?.label || !weightControl) {
            return;
          }

          if(vehicleOption.label.includes('Over 7.5T.')) {
            weightControl.setValue('Over 7.5T.');
          } else {
            weightControl.setValue('Up to 7.5T.');
          }
        }
      })
  }

  enablePostcode(value, vehicleIndex: number) {
    if (value == null) {
      this.vehicles.at(vehicleIndex).get('kept_at_postcode').disable();
    } else {
      if (!value) {
        this.vehicles.at(vehicleIndex).get('kept_at_postcode').enable();
      } else {
        this.vehicles.at(vehicleIndex).get('kept_at_postcode').disable();
      }
    }
  }

  /**
   * Get vehicle data from dvla
   */
  public onRegistrationNumberChange(event) {
    this.breakdownService
      .getVehicleDetails(event.target.value, this.authDetails)
      .subscribe({
        next: (res: any) => {
          if (res.meta) {
            console.log('Vehicle Details:', res.meta);
            this.formFields.patchValue({
              vehicles: {
                make: res.meta.make,
                model: res.meta.model,
                value: res.meta.value,
                weight: res.meta.weight === '0T - 3.50T' ? 'Up to 7.5T.' : (res.meta.weight || ''),
                year: res.meta.year,
              }
            })

          }
        },
        error: (err) => {
          this._snackBar.open('Vehicle not found.', '', {
            duration: 5000,
            panelClass: 'text-danger'
          });
        }
      });
  }

  public onSubmit() {
    this.submitted = true;
    if (this.formFields.invalid) {
      return false;
    }

    const vehicleOptionsId = this.calculateVehicleId();
    if (!vehicleOptionsId?.id) {
      this._snackBar.open('Unable to match vehicle weight/year to rating option.', '', {
        duration: 5000,
        panelClass: 'text-danger'
      });
      return false;
    }

    this.formFields.patchValue({
      vehicles: { 
        vehicle_hb_weight_id: vehicleOptionsId.id
      }
    });

    // This was causing subsequent code to be unreachable after a merge
    // return;

    const formVehicle = this.formFields.getRawValue().vehicles;
    const existingVehicle = Array.isArray(this.modelObject.vehicles) ? this.modelObject.vehicles[0] : (this.modelObject.vehicles || {});
    this.modelObject.vehicles = { ...existingVehicle, ...formVehicle };

    if (this.modelObject.type == 2) {
      this.modelObject.policy_id = null;
      this.modelObject.effective_date = null;
    }

    const qType = Number(this.modelObject.type);
    const isMtaOrCancel = qType === 3 || qType === 4;
    const isFirstSave = isFirstBreakdownMtaSave(this.modelObject, this.apiModelObject, qType, this.originalPolicyId);
    const oldPolicyId = resolveBreakdownOldPolicyId(this.modelObject, this.apiModelObject, this.originalPolicyId);

    const data = {
      "quote_data": {
        "id": isFirstSave ? null : this.modelObject.id,
        "company_id": this.modelObject.company_id,
        "policy_start_date": this.modelObject.inception_date || this.modelObject.policy_start_date,
        "policy_end_date": this.modelObject.policy_end_date || this.modelObject.cover_to,
        "broker_id": this.modelObject.broker_id,
        "type": this.modelObject.type,
        "policy_ref_number": this.modelObject.policyRefNumber || this.modelObject.policy_ref_number,
        "old_policy_id": oldPolicyId,
        "sequence_number": this.modelObject.sequenceNumber || this.modelObject.sequence_number,
        "quote_meta_id": this.modelObject.quote_meta_id,
        ...(qType === 3 ? { "effective_date": this.modelObject.effectiveDate || this.modelObject.effective_date } : {}),
        "policy_holder": {
          "title": this.modelObject.policy_holder_detail.title,
          "first_name": this.modelObject.policy_holder_detail.first_name,
          "last_name": this.modelObject.policy_holder_detail.last_name,
          "email": this.modelObject.policy_holder_detail.email,
          "phone": this.modelObject.policy_holder_detail.phone,
          "mobile": this.modelObject.policy_holder_detail.mobile ? this.modelObject.policy_holder_detail.mobile : '',
          "dob": this.modelObject.policy_holder_detail.dob,
          "company_name": this.modelObject.policy_holder_detail.company_name ? this.modelObject.policy_holder_detail.company_name : '',
          "trading_name": this.modelObject.policy_holder_detail.trading_name ? this.modelObject.policy_holder_detail.trading_name : '',
          "proposer_type": this.modelObject.policy_holder_detail.proposer_type,
          "is_micro_enterprise": coerceBreakdownIsMicroEnterprise(this.modelObject.policy_holder_detail),
          "address": {
            "address1": this.modelObject.policy_holder_detail.address.address1,
            "address2": this.modelObject.policy_holder_detail.address.address2,
            "address3": this.modelObject.policy_holder_detail.address.address3,
            "address4": this.modelObject.policy_holder_detail.address.address4,
            "city": this.modelObject.policy_holder_detail.address.city,
            "country": "UK",
            "postcode": this.modelObject.policy_holder_detail.address.postcode,
          },
          "sms": this.modelObject.policy_holder_detail.sms,
          "post": this.modelObject.policy_holder_detail.post,
          "is_phone": this.modelObject.policy_holder_detail.is_phone,
          "is_email": this.modelObject.policy_holder_detail.is_email,
        },
        "vehicle_details": [this.modelObject.vehicles],
      }
    };

    this.breakdownService.saveQuote(data)
      .subscribe(
        (res: any) => {
          if (res.success) {
            if (res.result.quote) {
              this.modelObject = res.result.quote;
              
              // add vehicles
              this.modelObject.vehicles.forEach((res) => {
                res.breakdown_cover = false;
                const drivers = [];
                if (res.drivers && res.drivers.length > 0) {
                  res.drivers.forEach((d) => {
                    drivers.push(d.driver);
                  })
                }

                res.drivers = drivers;
              })
              // emit data
              this.modelObjectUpdated.emit(this.modelObject);
            }
            return;
          } 

          this._snackBar.open(res.message, '', {
            duration: 5000,
            panelClass: 'text-danger'
          });
        });
  }

  /**
   * Get access token
   */
  public getAccessToken() {
    let data = {
      'client_id': environment.AMLINE_CLIENT_ID,
      'client_secret': environment.AMLINE_CLIENT_SECRET,
      'grant_type': environment.AMLINE_GRANT_TYPE,
      'scope': environment.AMLINE_SCOPE,
    }
    this.breakdownService.getAccessToken(data)
      .subscribe({
        next: (response: any) => {
          if (response.access_token) {
            this.authDetails = response;
            this.getStaticData();
          }
        },
      });
  }

  public calculateVehicleId(){ 
    const rawWeight = this.vehicles.get('weight').value;
    const rawYear = this.vehicles.get('year').value;
    const year = Number(rawYear);
    const weight = rawWeight === '0T - 3.50T'
      ? 'Up to 7.5T.'
      : rawWeight === '3.50T+'
        ? 'Over 7.5T.'
        : rawWeight;

    if (!year || !weight) {
      return null;
    }

    // Calculate the year difference
    const carYear = new Date(`${year}-01-01`);
    const currentYear = new Date();
    const yearDiff = currentYear.getFullYear() - carYear.getFullYear();
    
    // Set correct vehcile option 
    let label = '';
    if(yearDiff <= 15){
      label += '0-15 Years';
    } else {
      label += '16+ Years';
    }

    label += ` ${weight}`;

    return this.vehicleOptions.find((option) => option.label === label) || null;
  }

  /**
   * Get statis data
   * @param response
   */
  public getStaticData() {
    this.breakdownService
      .getStaticData(this.authDetails)
      .subscribe({
        next: (response: any) => {
          if (response.meta) {
            this.staticData = response.meta;
          }
        },
      });
  }

}
